import * as React from "react";
import range from "lodash/range";

const MonthMin = 1;
const MonthMax = 12;
const Months = range(MonthMin, MonthMax + 1, 1);

export const MonthOptions: React.SFC<{}> = () => {
  return (
    <>
      <option />
      {Months.map(month => {
        return (
          <option key={month} value={month}>
            {month}
          </option>
        );
      })}
    </>
  );
};

const YearRange = 120; // 120 is the used number of enterprise company edit page.
const ThisYear = new Date().getFullYear();
const Years = range(ThisYear, ThisYear - YearRange, -1);

export const YearOptions: React.SFC<{}> = () => {
  return (
    <>
      <option />
      {Years.map(year => {
        return (
          <option key={year} value={year}>
            {year}
          </option>
        );
      })}
    </>
  );
};



// WEBPACK FOOTER //
// ./frontend/src/common/components/DateOptions.tsx